import { httpClient } from '../http/httpClient.js';

const MY_COMPANY_API_URL = '/api/company/myCompany';
const COMPANY_API_URL = '/api/company';

const normalizeStorage = (storage = {}) => ({
  unit: storage.unit ?? 'MB',
  limit: Number(storage.limit) || 0,
  used: Number(storage.used) || 0,
  free: Number(storage.free) || 0,
  percentage: Number(storage.percentage) || 0,
  images: Number(storage.images) || 0,
  documents: Number(storage.documents) || 0
});

export const myCompanyService = {
  getMyCompany: async () => {
    const payload = await httpClient.get(MY_COMPANY_API_URL);
    return {
      company: {
        id: payload?.company?.id ?? null,
        name: payload?.company?.name ?? '',
        planId: payload?.company?.planId ?? null,
        baseLat: payload?.company?.baseLat ?? null,
        baseLng: payload?.company?.baseLng ?? null
      },
      technicianCount: Number(payload?.technicianCount) || 0,
      storage: normalizeStorage(payload?.storage)
    };
  },

  getMyCompanyIcon: async () => {
    try {
      return await httpClient.get(`${COMPANY_API_URL}/icon`, { parseAs: 'blob' });
    } catch (error) {
      // Una empresa sin icono puede responder 404; no es un error para la vista.
      if (error?.status === 404) return null;
      throw error;
    }
  },

  updateMyCompanyIcon: async (file) => {
    const formData = new FormData();
    formData.append('icon', file);

    return httpClient.put(`${COMPANY_API_URL}/icon`, { body: formData });
  }
};
